import { install } from 'ga-gtag';

const trackingId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

export const gtag = (): void => {
  if (!trackingId) return;
  install(trackingId);
};
